var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComscore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 680",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#54c8e8;}.cls-2{fill:#ffa400;}.cls-3{fill:#e43d30;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Comscore_Icon_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "765.41 264.69 765.41 390.17 514.59 415.2 514.59 485.46 860.7 520 860.7 255.29 765.41 264.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "765.41 264.69 765.41 194.14 419.3 160 419.3 424.71 514.59 415.2 514.59 289.43 765.41 264.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "765.41 264.69 514.59 289.43 514.59 415.2 765.41 390.17 765.41 264.69"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComscore);
export default __webpack_public_path__ + "static/media/comscore.1211a7fb97b71ef0ec2eb05a73be470a.svg";
export { ForwardRef as ReactComponent };